import { makePropCacheMixin } from '../utils/cache'

export default makePropCacheMixin('$attrs', 'bvAttrs')
